import { render } from "./Exam.vue?vue&type=template&id=49201b14"
import script from "./Exam.vue?vue&type=script&lang=ts"
export * from "./Exam.vue?vue&type=script&lang=ts"
script.render = render

export default script